<template>
  <v-dialog v-model="dialog" max-width="800px" scrollable>
    <v-card v-if="tournament">
      <v-card-title class="primary--text">
        {{ tournament.name }}
      </v-card-title>
      <v-divider></v-divider>

      <v-card-text class="pa-6">
        <!-- Información general -->
        <v-row class="mb-6">
          <v-col cols="12" sm="6">
            <div class="mb-4">
              <span class="text-caption grey--text font-weight-bold">FECHA</span>
              <div class="text-subtitle-1">
                <v-icon small>mdi-calendar</v-icon>
                {{ formatDate(tournament.start_date) }}
              </div>
            </div>

            <div class="mb-4">
              <span class="text-caption grey--text font-weight-bold">CANCHA</span>
              <div class="text-subtitle-1">
                <v-icon small>mdi-golf</v-icon>
                {{ tournament.course }}
              </div>
            </div>

            <div class="mb-4">
              <span class="text-caption grey--text font-weight-bold">ESTADO</span>
              <div>
                <v-chip :color="getStatusColor(tournament.status)" small text-color="white">
                  {{ getStatusLabel(tournament.status) }}
                </v-chip>
              </div>
            </div>
          </v-col>

          <v-col cols="12" sm="6">
            <div class="mb-4">
              <span class="text-caption grey--text font-weight-bold">INSCRITOS</span>
              <div class="text-subtitle-1">
                {{ tournament.current_players }} / {{ tournament.max_players }}
              </div>
              <v-progress-linear
                :value="getParticipationPercentage(tournament)"
                height="8"
                class="mt-2"
                :color="tournament.is_full ? 'error' : 'primary'"
              ></v-progress-linear>
            </div>

            <div class="mb-4">
              <span class="text-caption grey--text font-weight-bold">HANDICAP</span>
              <div class="text-subtitle-1">
                {{ tournament.handicap_min }} - {{ tournament.handicap_max }}
              </div>
            </div>

            <div v-if="!isRegistered" class="mb-4">
              <span class="text-caption grey--text font-weight-bold">ESPACIOS DISPONIBLES</span>
              <div class="text-subtitle-1">
                <span class="success--text font-weight-bold">
                  {{ tournament.available_slots }}
                </span>
              </div>
            </div>
          </v-col>
        </v-row>

        <!-- Descripción -->
        <v-divider class="mb-4"></v-divider>
        <div v-if="tournament.description" class="mb-6">
          <span class="text-caption grey--text font-weight-bold">DESCRIPCION</span>
          <p class="mt-2 grey--text">{{ tournament.description }}</p>
        </div>

        <!-- Horarios -->
        <v-divider v-if="tournament.tee_times?.length > 0" class="mb-4"></v-divider>
        <div v-if="tournament.tee_times?.length > 0" class="mb-6">
          <span class="text-caption grey--text font-weight-bold">HORARIOS DISPONIBLES</span>
          <div class="mt-3">
            <v-chip
              v-for="(time, index) in tournament.tee_times"
              :key="index"
              outlined
              small
              class="mr-2 mb-2"
            >
              {{ time.hour }} ({{ time.slots }} salidas)
            </v-chip>
          </div>
        </div>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('close')">Cerrar</v-btn>
        <v-btn
          v-if="!isRegistered && !tournament.is_full && ![3, 6].includes(tournament.status)"
          color="primary"
          @click="$emit('register', tournament)"
        >
          Inscribirse
        </v-btn>
        <v-chip
          v-else-if="isRegistered"
          color="success"
          small
          text-color="white"
        >
          Ya estas inscrito
        </v-chip>
        <v-chip
          v-else-if="tournament.is_full"
          color="error"
          small
          text-color="white"
        >
          Torneo lleno
        </v-chip>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'TournamentDetailDialog',
  props: {
    tournament: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    isRegistered: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialog: true
    }
  },
  methods: {
    getStatusLabel (status) {
      const labels = {
        1: 'Pendiente',
        2: 'Confirmado',
        3: 'Cancelado',
        4: 'En curso',
        5: 'Finalizado',
        6: 'Cancelado'
      }
      return labels[status] || 'Desconocido'
    },
    getStatusColor (status) {
      const colors = {
        1: 'warning',
        2: 'success',
        3: 'grey',
        4: 'info',
        5: 'purple',
        6: 'grey'
      }
      return colors[status] || 'grey'
    },
    formatDate (date) {
      return new Date(date).toLocaleDateString('es-ES', {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
        year: 'numeric'
      })
    },
    getParticipationPercentage (tournament) {
      return (tournament.current_players / tournament.max_players) * 100
    }
  }
}
</script>

<style scoped>
::v-deep .v-dialog__container {
  align-items: flex-start;
  padding-top: 20px;
}
</style>
